<template>
  <div class="arch-items-container btns4">
    <button
      class="arch-item"
      :class="{ active: activeStep === 'step1' }"
      @click="goToStep('step1')"
      :disabled="activeStep === 'step1'"
    >
      {{ titles[0] }}
    </button>
    <button
      class="arch-item"
      :class="{ active: activeStep === 'step2' }"
      @click="goToStep('step2')"
      :disabled="activeStep === 'step2'"
    >
      {{ titles[1] }}
    </button>
    <button
      class="arch-item"
      :class="{ active: activeStep === 'step3' }"
      @click="goToStep('step3')"
      :disabled="activeStep === 'step3'"
    >
      {{ titles[2] }}
    </button>
    <button
      class="arch-item"
      :class="{ active: activeStep === 'step4' }"
      @click="goToStep('step4')"
      :disabled="activeStep === 'step4'"
    >
      {{ titles[3] }}
    </button>

    <button
      v-if="!orderError"
      class="send-order-btn"
      @click="$emit('submit-order')"
      :class="{ visible: activeStep === 'step4' }"
      :disabled="orderError || uploading"
      :title="uploading ? 'Wacht tot het uploaden klaar is' : ''"
    >
      <span v-if="uploading">Upload<br />bezig...</span>
      <span v-else>Bestelling afronden</span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //orderError: false
      //activeStep: 'step1'
    }
  },
  props: {
    titles: Array,
    activeStep: String,
    errors: Number,
    uploading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToStep(step) {
      //this.activeStep = step
      this.$emit('go-to-step', step)
    }
  },
  computed: {
    orderError() {
      return this.errors > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@use '../sass/helpers/_mixins.scss' as *;
@use '../sass/base/_colors.scss' as *;

.arch-items-container {
  display: none;
  //display: flex;
  align-items: center;
}
.arch-item {
  @include eclipse(54px);
  background-color: var(--arch-color);
  //box-shadow: rgba(0, 0, 0, 0.4) 0 0 5px;
  box-shadow: var(--default-shadow);
  color: var(--arch-text-color);
  font-size: 9px;
  font-weight: 500;
  padding: 0;
  transition: 0.3s all;
  transform: scale(0, 0);
  animation: archbtn 0.25s ease-out forwards;

  @keyframes archbtn {
    to {
      transform: scale(1, 1);
    }
  }

  &.active {
    @include eclipse(65px);
    font-size: 10px;

    &:hover {
      box-shadow: var(--default-shadow-hover);
    }
  }

  &:nth-of-type(1) {
    animation-delay: 0.25s;
  }

  &:nth-of-type(2) {
    animation-delay: 0.35s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.45s;
  }

  &:nth-of-type(4) {
    animation-delay: 0.55s;
  }
}

.send-order-btn {
  @include eclipse(54px);
  box-shadow: var(--default-shadow);
  background-color: var(--action-color);
  transition: all 0.2s;
  transform: scale(0, 0);
  vertical-align: middle;

  &.visible {
    transform: scale(1, 1);
  }

  &:hover {
    transform: scale(1.1, 1.1);
    box-shadow: var(--default-shadow-hover);
  }

  span {
    color: white;
    font-size: 11px;
    font-weight: 500;
  }

  &:disabled {
    background-color: #f9f9f9;

    span {
      color: #a7a7a7;
    }
  }
}

/* @media only screen and (min-width: 375px) {
  .arch-item {
    @include eclipse(63px);
    font-size: 10px;

    &.active {
      @include eclipse(74px);
      font-size: 11px;
    }
  }

  .send-order-btn {
    @include eclipse(63px);
  }
}

@media only screen and (min-width: 620px) {
  .arch-items-container {
    //max-width: 460px;
    height: 114px;
  }
  .arch-item {
    @include eclipse(80px);
    font-size: 12px;

    &.active {
      @include eclipse(100px);
      font-size: 15px;
    }
  }

  .send-order-btn {
    @include eclipse(74px);
  }
}

@media only screen and (min-width: 768px) {
  .arch-items-container {
    display: flex;
    position: relative;
    height: 100px;
    left: 267px;
    top: -86px;
  }

  .arch-item {
    display: block;
    float: left;

    @keyframes archbtn {
      to {
        transform: scale(1, 1);
      }
    }
  }
} */

@media only screen and (min-width: 1024px) {
  .arch-items-container {
    //max-width: 537px;
    display: flex;
    position: relative;
    height: 116px;
    left: -77px;
    //left: -62px;
    top: -12px;
  }

  .arch-item {
    width: 95px;
    height: 95px;
    border-radius: 50%;
    font-size: 12px;

    &:hover {
      box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 9px;
      width: 110px;
      height: 110px;
      font-size: 13px;
    }

    &.active {
      width: 115px;
      height: 115px;
      border-radius: 50%;
      font-size: 14px;
    }

    &:nth-of-type(2) {
      margin-top: -139px;
      margin-left: -7px;
    }

    &:nth-of-type(3) {
      margin-top: -199px;
      margin-left: 13px;
    }

    &:nth-of-type(4) {
      margin-top: -133px;
      margin-left: 10px;
    }
  }

  .send-order-btn {
    margin-left: -9px;
    margin-top: 11px;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    span {
      font-size: 0.82rem;
      line-height: normal;
    }
  }
}

/* @media only screen and (min-width: 1280px) {
  .arch-items-container {
    max-width: 550px;
  }
} */
</style>
